// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false
};

const hostname = window.location.hostname;

export const APPLICATION_SERVER_URL =
  hostname.includes("localhost") || hostname.includes("app-beta.singlefinapp.it")
    || hostname.includes("192.168") || hostname.includes("127.0") || hostname.includes("10.0")
    || hostname.includes("https://singlefin-app-git-git-modifiche-2026-francescodegiorgio.vercel.app")
    || hostname.includes("https://singlefin-app-git-git-modifiche-2026-pt2-francescodegiorgio.vercel.app")
    ? "https://www.sunsetbeachapp.it"
    : "https://www.singlefinapp.it";

export const STRIPE_KEY = "pk_test_51T8IrwA7fKoaTGIpDpAGkbg4vq68PXXoVGDLHo6KYMOe5imSVKg88ian95ZKzOFn3dnN7bznTe1c4pP6ZVxItcKX00QpzjuGvt";

export const idModalitaPagamento = {
  contanti: 1,
  payPal: 2,
  stripe: 3,
  braintree: 4
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
